import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.extraHoursTable],
        config: {
            headerName: getLocalizedString("overtimeCode"),
            field: "code",
            isObligatory: true,
            maxLength: 8,
            minLength: 1,
        }
    },
    {
        pages: [paths.extraHoursTable],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            isObligatory: true,
            maxLength: 20,
            minLength: 1,
        }
    },
    {
        pages: [paths.extraHoursTable],
        config: {
            headerName: getLocalizedString("hourType"),
            field: "type",
            isObligatory: true,
            isSelect: true,
        }
    },
]